import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['toggle', 'intervalInput'];

	connect() {
		if (!this.hasToggleTarget || !this.hasIntervalInputTarget) {
			return;
		}

		this.boundSyncInterval ??= this.syncInterval.bind(this);
		this.syncInterval();
		this.toggleTarget.addEventListener('change', this.boundSyncInterval);
	}

	disconnect() {
		if (!this.boundSyncInterval || !this.hasToggleTarget) {
			return;
		}

		this.toggleTarget.removeEventListener('change', this.boundSyncInterval);
	}

	syncInterval() {
		this.intervalInputTarget.value = this.toggleTarget.checked ? 'annual' : 'monthly';
	}
}
